var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBasicPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DCDAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2384 12.786C16.151 12.7422 16.1073 12.7204 16.0614 12.7118C16.0208 12.7041 15.9791 12.7041 15.9385 12.7118C15.8926 12.7204 15.8489 12.7422 15.7614 12.786L9.33325 16L15.7614 19.2141C15.8489 19.2578 15.8926 19.2797 15.9385 19.2883C15.9791 19.2959 16.0208 19.2959 16.0614 19.2883C16.1073 19.2797 16.151 19.2578 16.2384 19.2141L22.6666 16L16.2384 12.786Z",
    stroke: "#5148D7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPlanIcon);
export default __webpack_public_path__ + "static/media/basic-plan-icon.3703663d.svg";
export { ForwardRef as ReactComponent };